export default __webpack_public_path__ + "static/media/photo--sm--misc-9.76946291.jpg";